module.exports = __webpack_public_path__ + "media/src/assets/Images/Garages-0ae4418ef70e16a7350cfc19e2b88af2.svg";